<div *ngIf="vcPatientDetails" class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex flex-row flex-wrap items-center">
      <!-- Firstname and Surname -->
      <div class="font-bold">
        {{ vcPatientDetails?.patient?.data?.surname ?? '' }},
        {{ vcPatientDetails?.patient?.data?.name ?? '' }},
      </div>

      <!-- Gender -->
      <div class="ml-1 font-bold">
        {{ 'GENERAL.' + (vcPatientDetails?.patient?.data?.gender ?? '') | translate }},
      </div>

      <!-- Birthday and Age -->
      <div class="ml-1">
        {{
          vcPatientDetails?.patient?.data?.birth_date | date: ('GENERAL.date_format' | translate)
        }}
        <span class="font-bold">({{ vcPatientDetails?.patient?.data?.birth_date | calAge }})</span>
      </div>

      <!-- Admission Date -->
      <div class="ml-1">
        A:
        {{ vcPatientDetails?.case?.data?.admission_date | date: ('GENERAL.date_format' | translate)
        }}<span *ngIf="vcPatientDetails?.case?.data?.discharge_date">,</span>
      </div>

      <!-- Discharge Date -->
      <ng-container *ngIf="vcPatientDetails?.case?.data?.discharge_date">
        <div>
          {{ 'COMPONENT.PAGE_PATIENT_LIST.planned_discharge_date' | translate }}:
          {{
            vcPatientDetails?.case?.data?.discharge_date | date: ('GENERAL.date_format' | translate)
          }}
          ({{
            calculateHospitalStayDays(
              vcPatientDetails?.case?.data?.admission_date,
              vcPatientDetails?.case?.data?.discharge_date
            ) | number: '1.0-0'
          }})
        </div>
      </ng-container>
    </div>
  </div>
</div>
